import React from 'react';
import Layout from 'components/Layout';
import ContentTerminosPolitica from 'components/ContentTerminosPolitica';
import { qr_links } from 'config';
import AccountTabsQr from 'components/AccountTabsQr';

const PoliCookiesQRPublic = () => {

 

    return (
        <div className="mi-cuenta cupones ">
           
            <Layout showBanner={false }>
                
                <section className="my-account">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-lg-3 mt-4 left-menu">
                                <AccountTabsQr currentPath={qr_links.cookies_public}/>
                            </div>
                            <div className="col-12 col-lg-9 mt-4">
                                <div className="border">
                                    <div className="row">
                                        <div className="col-12 text-content">
                                         <ContentTerminosPolitica typeContent="cookies" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <br /><br /><br />
                                <br /><br /><br />
                                <br /><br /><br />
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
        </div>
    )
};

export default PoliCookiesQRPublic;